/**
 * ISM ağacında formun kayıtları (ADR 0072): üçüncü düzeyin metinleri. `documents.ts` bunları
 * `documents.tree.records` altına katar.
 */

export const documentsTreeRecordsEn = {
  /** Ofiste ağacın üstündeki gemi seçici. */
  vessel: 'Vessel records',
  selectVessel: 'Select a vessel to see records',
  /** Dar ağaç sütununa sığan kısa yer tutucu. */
  pickVessel: 'Select vessel',
  expand: 'Show records',
  loading: 'Loading records…',
  error: 'Records could not be loaded. Select to try again.',
  empty: 'No records yet',
  all: 'All ({{count}})',
  allLabel: 'All {{count}} records of this form',
  submitted: 'Submitted',
  waitingFor: 'Waiting for {{role}}',
  overdue: 'Overdue',
};

export const documentsTreeRecordsTr: typeof documentsTreeRecordsEn = {
  vessel: 'Geminin kayıtları',
  selectVessel: 'Kayıtları görmek için gemi seçin',
  pickVessel: 'Gemi seçin',
  expand: 'Kayıtları göster',
  loading: 'Kayıtlar yükleniyor…',
  error: 'Kayıtlar yüklenemedi. Yeniden denemek için seçin.',
  empty: 'Henüz kayıt yok',
  all: 'Tümü ({{count}})',
  allLabel: 'Bu formun {{count}} kaydının tümü',
  submitted: 'Gönderildi',
  waitingFor: '{{role}} onayı bekleniyor',
  overdue: 'Süresi geçti',
};
